module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA1ElEQVR4AWOgC7inKUAkQtdwV03gngYI3dfjfxHPfV9H4J46dg0gRXekBZ+F8dw34L+jIHBfn/9FIvcDI/77ekApbBoemPC/LuD6eYD50wz2p4E8d1UF7sgIvkjgfpHEfVcJm4a7KoKvi7j+f2H4dYjpgSn/PTWQNMhJOjicdFdJ8HkEz5tSrjcVnCBnqAvckRd8HsUDRHeVcXlaR+COgiDI39oC97UFHjvxPbLne2TLB9SMQ4MGlASqeGDI/6acE+iku6o4nISJ7qoRjgdMRLmGQQkAemmuMEdBytEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CN.png
// module id = 1113
// module chunks = 0